var hulk_custom_pagination_page = 1;
var hulk_custom_pagination_max;
var is_eligible_preview = false;
var custom_product_status = {};

const product_image_map = {
    'Espresso Martini': 'https://cdn.shopify.com/s/files/1/0558/9463/8783/files/Espresso_Martini_-_Front.jpg?v=1744951574',
    'Margarita': 'https://cdn.shopify.com/s/files/1/0558/9463/8783/files/Margarita_-_Front.jpg?v=1744951574',
    'Negroni': 'https://cdn.shopify.com/s/files/1/0558/9463/8783/files/Negroni_-_Front.jpg?v=1744951575',
    'Rosella Lychee Martini': 'https://cdn.shopify.com/s/files/1/0558/9463/8783/files/Rosea_Lychee_-_Front.jpg?v=1744951574'
}

let test_preview_image = 'https://cdn.shopify.com/s/files/1/0558/9463/8783/files/Blank_template.jpg?v=1744958030';

function hulk_custom_init() {
    $ = hulkapps_jQuery;

    function initStepWrapper(stepName, page) {
        const html = `<div class="single-step" data-page="${page}"><div class="step-top">•</div><div class="step-bottom">${stepName}</div></div>`;
        $('.hulk_pagination.step_wrapper').append(html);
    }

    function updateStepWrapper() {
        $('.single-step').each(function () {
            $(this).removeClass('active');
            if ($(this).attr('data-page') == hulk_custom_pagination_page) {
                $(this).addClass('active');
            }
        })
    }

    function createInputButtons(input) {
        $('<div class="increment_button" data-quantity="decrease">-</div>').insertBefore($(input));
        $('<div class="increment_button" data-quantity="increase">+</div>').insertAfter($(input));
        attachInputButtonActions(input);
    }

    function attachInputButtonActions(input) {
        $(input).parent().on('click', '.increment_button', function (e) {
            $this_input = $(e.target).parent().find('input[type="number"]');
            $this_hinput = $(e.target).parent().find('input[type="hidden"]');
            $select_reference = $(e.target).parent().find('select option.price-change').first();
            if (e.target.dataset.quantity == 'decrease' &&
                $this_input.val() > input.min) {
                $this_input.val(parseInt($this_input.val()) - 1);
                $this_input.change();
                $this_hinput.val($select_reference.val() + ' | ' + $this_input.val());
            } else if (e.target.dataset.quantity == 'increase') {
                $this_input.val(parseInt($this_input.val()) + 1);
                $this_input.change();
                $this_hinput.val($select_reference.val() + ' | ' + $this_input.val());
            }
            window.calc_options_total(window.hulkapps.product.id);
        })
    }

    function hulk_attachPaginateListeners() {
        $('.hulk_go_next').on('click', async function () {
            let error = 0;
            await validate_options(window.hulkapps.product_id);
            $(`.pagination_page-${hulk_custom_pagination_page}`).each(function () {
                if ($(this).hasClass('validation_error')) error = 1;
            })
            $(`.validation_error:not(.pagination_page-${hulk_custom_pagination_page})`).removeClass('validation_error');
            if (!error) {
                hulk_custom_pagination_page++;
                hulk_paginate();
            }
        })
        $('.hulk_go_back').on('click', function () {
            hulk_custom_pagination_page--;
            hulk_paginate();
        })
        $('.product-form__item--payment-button').hide();
        $('.hulk_atc').on('click', function () {
            $('.product-form__item--payment-button button.hulkapps_submit_cart').click();
        })
    }

    function hulk_getPaginateMax() {
        const pages = new Set();
        $('[class*="pagination_page"]').each(function () {
            pages.add(parseInt(Array.from($(this).get()[0].classList).find((el => el.startsWith('pagination_page'))).at(-1)));
        })
        hulk_custom_pagination_max = Math.max.apply(null, Array.from(pages));
    }

    function hulk_paginate() {
        $ = hulkapps_jQuery;
        $('[class*="pagination_page"]').each(function () {
            if (!($(this).hasClass(`pagination_page-${hulk_custom_pagination_page}`))) {
                $(this).hide();
            } else $(this).show();
        })
        if (hulk_custom_pagination_page > 1) $('.hulk_go_back').removeClass('hulk_hide');
        else $('.hulk_go_back').addClass('hulk_hide');
        if (hulk_custom_pagination_page == hulk_custom_pagination_max) {
            $('.hulk_go_next').addClass('hulk_hide');
            $('.hulk_atc').removeClass('hulk_hide');
            $('.hulkapps_option.hulk_cocktail_preview .cocktail_preview_wrapper').remove();
            $(`.hulk_cocktail_preview .hulkapps_option_value`).append($('.cocktail_preview_wrapper').clone());
        } else {
            $('.hulk_go_next').removeClass('hulk_hide');
            $('.hulk_atc').addClass('hulk_hide');
        }
        updateStepWrapper();
        document.querySelector('.product__headline').scrollIntoView();
    }

    function wrapGiftBoxDiv() {
        const giftBoxOptions = document.querySelectorAll('.giftbox_flavour');
        $(giftBoxOptions[0]).wrap('<div class="giftbox_wrapper_div"></div>');
        for (let i = 1; i <= giftBoxOptions.length; i++) {
            $('.giftbox_wrapper_div').append($(giftBoxOptions[i]));
        }
    }

    function getGiftBoxChoice() {
        $('.giftbox_flavour select').on('change', function (e) {
            const _this = e.target;
            const $choiceElement = $(_this).closest('.giftbox_flavour').find('.gift_choice_preview');

            if ($choiceElement.length) {
                $choiceElement.slideUp(300, function () {
                    $(this).remove();
                });
            }
            setTimeout(() => {
                if (product_image_map[_this.value]) {
                    const $newPreview = $(`
                        <div class="gift_choice_preview" style="display:none">
                        </div>
                    `);

                    $(_this).after($newPreview);
                    $(_this).next().append($(product_image_map[_this.value].cloneNode(!0)));
                    $newPreview.slideDown(700);
                }
            }, 400)
        });
    }

    function getFirstMondayFourWeeksFuture() {
        const today = new Date();
        const dayOfWeek = today.getDay();

        let daysToNextMonday;
        if (dayOfWeek === 0) {
            daysToNextMonday = 1;
        } else {
            daysToNextMonday = 8 - dayOfWeek;
        }

        const firstUpcomingMonday = new Date(today);
        firstUpcomingMonday.setDate(today.getDate() + daysToNextMonday);

        const fourWeeksFromNow = new Date(today);
        fourWeeksFromNow.setDate(today.getDate() + 28);

        let targetMonday = new Date(firstUpcomingMonday);

        while (targetMonday < fourWeeksFromNow) {
            targetMonday.setDate(targetMonday.getDate() + 7);
        }

        const year = targetMonday.getFullYear();
        const month = String(targetMonday.getMonth() + 1).padStart(2, '0');
        const day = String(targetMonday.getDate()).padStart(2, '0');

        return `${year}-${month}-${day}`;
    }

    function cocktailShowCase() {
        const showcaseWrapper = document.createElement('div');
        showcaseWrapper.classList.add('cocktail_showcase', 'pagination_page-1');
        for (const image in product_image_map) {
            const singleCocktailElement = document.createElement('label');
            singleCocktailElement.setAttribute('for', image);
            const singleCocktailInput = document.createElement('input');
            singleCocktailInput.type = 'checkbox';
            singleCocktailElement.appendChild(singleCocktailInput);
            singleCocktailElement.classList.add('single_cocktail_element');
            singleCocktailElement.appendChild(product_image_map[image]);
            $(singleCocktailElement).append(`
                <div> 
                <span class="cocktail_name"> ${image} </span>
                    <div>
                        <input class="cocktail_bottle_count" min="0" type="number" value="0">
                    </div>
                </div>
                `);
            createInputButtons(singleCocktailElement.querySelector('input[type="number"]'));
            showcaseWrapper.appendChild(singleCocktailElement);
        }
        return showcaseWrapper
    }

    function returnImageFromReader(fileInput) {
        const file = fileInput?.files[0];
        if (file) {
            const image = document.createElement('img');
            const reader = new FileReader();
            reader.addEventListener('load', () => {
                image.src = reader.result
            }, false);
            reader.readAsDataURL(file);
            return image
        } else {
            console.warn('No image provided');
        }
    }

    function previewElementObserver() {
        const elementsToMonitor = document.querySelectorAll('.background_colour input[type="hidden"], .text_colour input[type="hidden"], .couples_names input[type="hidden"], .wedding_date input[type="hidden"], .custom-font-picker input[type="hidden"], .custom-occasion input[type="hidden"], .date_format input[type="hidden"], .custom_occasion input[type="hidden"]');
        const config = { attributes: true };
        elementsToMonitor.forEach((element) => {
            const callback = function (mutations, observer) {
                for (const mutation of mutations) {
                    if (mutation.type === 'attributes') {
                        const thisEle = mutation.target;
                        if (thisEle.closest('.hulkapps_option').classList.contains('background_colour')) {
                            custom_product_status.background_color = thisEle.value;
                        }
                        else if (thisEle.closest('.hulkapps_option').classList.contains('text_colour')) {
                            custom_product_status.text_color = thisEle.value;
                        } else if (thisEle.closest('.hulkapps_option').classList.contains('couples_names')) {
                            custom_product_status.couples_names = thisEle.value;
                        } else if (thisEle.closest('.hulkapps_option').classList.contains('wedding_date')) {
                            custom_product_status.wedding_date = thisEle.value;
                        } else if (thisEle.closest('.hulkapps_option').classList.contains('custom-font-picker')) {
                            custom_product_status.font = thisEle.value;
                        } else if (thisEle.closest('.hulkapps_option').classList.contains('custom-occasion')) {
                            custom_product_status.custom_occasion = thisEle.value;
                        } else if (thisEle.closest('.hulkapps_option').classList.contains('date_format')) {
                            custom_product_status.date_format = thisEle.value;
                        } else if (thisEle.closest('.hulkapps_option').classList.contains('custom_occasion')) {
                            custom_product_status.custom_text = thisEle.value;
                        }
                        triggerPreviewCycle();
                    }
                }
            }
            const observer = new MutationObserver(callback);
            observer.observe(element, config);
        })

        document.querySelector('.hulkapps_option.fu_render input[type="file"]')?.addEventListener('change', (e) => {
            if (e.target?.files[0]) {
                triggerPreviewCycle();
            }
        })
    }

    function triggerPreviewCycle() {
        if (Object.keys(custom_product_status > 0)) {
            is_eligible_preview = true;
            $('.cocktail_preview_wrapper').remove();
            $('#hulk-formbuilder-modal .hulkapps_option_value').append(generatePreview());
        } else {
            is_eligible_preview = false;
            $('.cocktail_preview_wrapper').remove();
        }
        toggleShowPreviewButton();
    }

    function toggleShowPreviewButton() {
        if (is_eligible_preview) $('.hulk_preview_button').show();
        else $('.hulk_preview_button').hide();
    }

    function generatePreview() {
        const previewWrapper = document.createElement('div');
        previewWrapper.classList.add('cocktail_preview_wrapper');

        // Inidividual flavour
        if (document.querySelector('.inidividual_flavour')) {
            const previewImage = prefetchImage(test_preview_image);
            previewWrapper.appendChild(previewImage);
            const customImageWrapper = document.createElement('div');
            customImageWrapper.classList.add('wrapper-relative');
            previewWrapper.appendChild(customImageWrapper);
            const $colourPicker = $('.hulkapps_option.cp_render.background_colour input[type="hidden"]');
            const fileUpload = document.querySelector('.hulkapps_option.fu_render input[type="file"]');
            if (fileUpload && fileUpload.files[0] != undefined) {
                const customImage = returnImageFromReader(fileUpload);
                customImageWrapper.appendChild(customImage);
            }
            if ($colourPicker.val() == '') {
                $colourPicker.val('#e8e8e8');
            }

            // Wedding favours
            if (custom_product_status.couples_names) {
                const name = custom_product_status.couples_names.split(' ');
                const couplesNames = document.createElement('div');
                couplesNames.classList.add('preview-couples_names');
                couplesNames.innerHTML = `${name[0]}<br>${name[1] ?? ''}<br>${name[2] ?? ''}`;
                customImageWrapper.appendChild(couplesNames);
            }

            if (custom_product_status.wedding_date && custom_product_status.date_format) {
                const weddingDate = document.createElement('div');
                weddingDate.classList.add('preview-wedding_date');
                if (custom_product_status.date_format == 'DD.MM.YYYY') {
                    weddingDate.textContent = formatDate(custom_product_status.wedding_date, 'DDMMYYYY');
                } else if (custom_product_status.date_format == 'DD Month YYYY') {
                    weddingDate.textContent = formatDate(custom_product_status.wedding_date, 'DDMonthYYYY');
                }
                customImageWrapper.appendChild(weddingDate);
            }
            $(customImageWrapper).css('background-color', $colourPicker.val());
        }

        if (document.querySelector('.giftbox_flavour')) {
            const previewImage = prefetchImage(test_preview_image);
            previewWrapper.appendChild(previewImage);
            const customImageWrapper = document.createElement('div');
            customImageWrapper.classList.add('wrapper-relative');
            previewWrapper.appendChild(customImageWrapper);
            const $colourPicker = $('.hulkapps_option.cp_render.background_colour input[type="hidden"]');
            const fileUpload = document.querySelector('.hulkapps_option.fu_render input[type="file"]');
            if (fileUpload && fileUpload.files[0] != undefined) {
                const customImage = returnImageFromReader(fileUpload);
                customImageWrapper.appendChild(customImage);
            }
            if ($colourPicker.val() == '') {
                $colourPicker.val('#e8e8e8');
            }

            // Special occaasion

            if (custom_product_status.custom_text) {
                const couplesNames = document.createElement('div');
                couplesNames.classList.add('preview-couples_names');
                couplesNames.innerHTML = custom_product_status.custom_text
                customImageWrapper.appendChild(couplesNames);
            }
            $(customImageWrapper).css('background-color', $colourPicker.val());
        }
        setTimeout(() => {

            if (custom_product_status.text_color) {
                $('.preview-couples_names, .preview-wedding_date').css('color', `${custom_product_status.text_color}`);
            } else {
                $('.preview-couples_names, .preview-wedding_date').css('color', 'white');
            }
            if (custom_product_status.font) {
                $('.preview-couples_names, .preview-wedding_date').css('font-family', custom_product_status.font);
                $('.preview-couples_names, .preview-wedding_date').css('font-weight', 'normal');

            }
        }, 500)

        return previewWrapper;
    }

    function checkDesignFee() {
        if (document.querySelector('.inidividual_flavour')) {
            const bottleCountInputs = document.querySelectorAll('input.cocktail_bottle_count');
            const isAddonCharge = document.querySelector('.hulkapps_option.individual_design_fee input[type="checkbox"]').checked;
            let cummulativeBottleCount = 0;
            bottleCountInputs.forEach((input) => {
                cummulativeBottleCount += parseInt(input.value);
            })
            if (cummulativeBottleCount >= 10) {
                $('.design_fee_success').show();
                $('.design_fee_error').hide();
                if (isAddonCharge) {
                    $('.hulkapps_option.individual_design_fee label').get()[0].click();
                }

            } else {
                $('.design_fee_error').show();
                $('.design_fee_success').hide();
                if (!isAddonCharge) {
                    $('.hulkapps_option.individual_design_fee label').get()[0].click();
                }
            }
        } else if (document.querySelector('.giftbox_flavour')) {
            const giftBoxCountInput = document.querySelector('.custom_quantity input.hulk_po_dropdown_quantity');
            const isAddonCharge = document.querySelector('.hulkapps_option.individual_design_fee input[type="checkbox"]').checked;
            const giftBoxCount = parseInt(giftBoxCountInput.value);
            if (giftBoxCount >= 5) {
                $('.design_fee_success').show();
                $('.design_fee_error').hide();
                if (isAddonCharge) {
                    $('.hulkapps_option.individual_design_fee label').get()[0].click();
                }

            } else {
                $('.design_fee_error').show();
                $('.design_fee_success').hide();
                if (!isAddonCharge) {
                    $('.hulkapps_option.individual_design_fee label').get()[0].click();
                }
            }
        }
        setTimeout(() => {
            window.calc_options_total(window.hulkapps.product.id);
        }, 800);
    }

    function monitorExtraCharge_1() {
        const elementToMonitor = document.querySelector('.hulkapps_option.extra_product_trigger_1');
        elementToMonitor.addEventListener('change', (e) => {
            if (e.target.checked) {
                $('.extra_product_1 label.hulkapps_radio_option').click();
                let bottleQnt = 0;
                $('input.cocktail_bottle_count').each((function () {
                    bottleQnt += parseInt($(this).val());
                }))
                setTimeout(() => {
                    $('.extra_product_1 input.hulk_po_radiobutton_quanity').val(bottleQnt);
                    $('.extra_product_1 input[type="hidden"]').val($('.extra_product_1 input[type="radio"]').val() + ' | ' + bottleQnt);
                    window.calc_options_total(window.hulkapps.product.id);
                }, 800);
            }
        })
    }

    function monitorExtraCharge_1_giftSet() {
        const elementToMonitor = document.querySelector('.hulkapps_option.extra_product_trigger_1');
        elementToMonitor.addEventListener('change', (e) => {
            if (e.target.checked) {
                $('.extra_product_1 label.hulkapps_radio_option').click();
                let bottleQnt = parseInt($('.custom_quantity input.hulk_options_quantity').val() * 3);
                setTimeout(() => {
                    $('.extra_product_1 input.hulk_po_radiobutton_quanity').val(bottleQnt);
                    $('.extra_product_1 input[type="hidden"]').val($('.extra_product_1 input[type="radio"]').val() + ' | ' + bottleQnt);
                    window.calc_options_total(window.hulkapps.product.id);
                }, 800);
            }
        })
    }

    function monitorExtraCharge_2_giftSet() {
        const elementToMonitor = document.querySelector('.hulkapps_option.extra_product_trigger_2');
        elementToMonitor.addEventListener('change', (e) => {
            if (e.target.checked) {
                $('.extra_product_2 label.hulkapps_radio_option').click();
                let bottleQnt = parseInt($('.custom_quantity input.hulk_options_quantity').val() * 3);
                setTimeout(() => {
                    $('.extra_product_2 input.hulk_po_radiobutton_quanity').val(bottleQnt);
                    $('.extra_product_2 input[type="hidden"]').val($('.extra_product_2 input[type="radio"]').val() + ' | ' + bottleQnt);
                    window.calc_options_total(window.hulkapps.product.id);
                }, 800);
            }
        })
    }

    function monitorIndividualFlavour() {
        $('.cocktail_bottle_count').on('change', function (e) {
            const bottleCount = e.target.value;
            const bottleType = e.target.closest('label').getAttribute('for');
            const relativeDropdown = document.querySelector(`.inidividual_flavour select[aria-label="Individual bottle - ${bottleType}"]`);
            if (relativeDropdown) {
                if (bottleCount > 0) {
                    relativeDropdown.querySelector(`option[value^="${bottleType}"]`).selected = true;
                    relativeDropdown.nextElementSibling.value = bottleCount;
                    relativeDropdown.nextElementSibling.nextElementSibling.value = `${relativeDropdown.value} | ${bottleCount}`;
                } else {
                    relativeDropdown.querySelector(`option[value^="${bottleType}"]`).selected = false;
                    relativeDropdown.nextElementSibling.value = bottleCount;
                    relativeDropdown.nextElementSibling.nextElementSibling.value = "";
                }
            }
            window.calc_options_total(window.hulkapps.product.id);
            checkDesignFee();
        })
    }

    function monitorGiftSetFlavour() {
        const config = { attributes: true };
        const elementToMonitor = document.querySelector('.custom_quantity input[type="hidden"]');
        const callback = function (mutations, observer) {
            for (const mutation of mutations) {
                if (mutation.type === 'attributes') {
                    checkDesignFee();
                }
            }
        }
        const observer = new MutationObserver(callback);
        observer.observe(elementToMonitor, config);
    }


    function monitorQrInput() {
        $('.hulkapps_option.qr_code_input input[type="text"]').on('input', function () {
            if (!isValidURL($(this).val())) {
                setTimeout(() => {
                    $(this).siblings('input[type="hidden"]').val('');
                }, 100);
                if (!$(this).closest('.hulkapps_option').find('.validation_error_message').length) {
                    $(this).after('<p class="validation_error_message">Provided link appears to be incorrect</p>');
                }
            } else {
                $(this).closest('.hulkapps_option').removeClass('validation_error');
                $(this).closest('.hulkapps_option').find('.validation_error_message').remove();
            }
        })
    }

    // Utilities

    function prefetchImage(url) {
        const img = new Image();
        img.setAttribute('height', '200px');
        img.setAttribute('width', '200px');
        img.src = url;
        return img;
    }

    function formatDate(dateString, format) {
        const date = new Date(dateString);
        const day = date.getDate();
        const month = date.getMonth() + 1; // Month is 0-indexed
        const year = date.getFullYear();
        const monthNames = ["January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"
        ];

        if (format === "DDMonthYYYY") {
            return `${day} ${monthNames[date.getMonth()]} ${year}`;
        } else if (format === "DDMMYYYY") {
            const formattedDay = String(day).padStart(2, '0');
            const formattedMonth = String(month).padStart(2, '0');
            return `${formattedDay}.${formattedMonth}.${year}`;
        } else {
            return "Invalid format"; // Or you could return the original date string or throw an error
        }
    }


    function isValidURL(text) {
        const urlRegex = /^(https?:\/\/)?(www\.)([\w-]+)\.([a-z]{2,})([\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]*)?$/i;
        return urlRegex.test(text);
    }

    let test_preview_image_element = prefetchImage(test_preview_image);

    for (const image in product_image_map) {
        product_image_map[image] = prefetchImage(product_image_map[image]);
    }

    // Call stack

    $('.pagination_step_data').find('li[data-step-page]').each(function () {
        initStepWrapper($(this).attr('data-step-name'), $(this).attr('data-step-page'));
    })
    $('.hulk_pagination.step_wrapper').insertBefore('[id^="hulkapps_custom_options_"]');

    $('.delivery_date input[type="date"]').attr('min', getFirstMondayFourWeeksFuture);

    $('.hulkapps_option.fu_render input[type="file"]').attr('accept', 'image/jpeg, image/jpg, image/png');

    $('product-form').after($('.product__block__description'));

    $('.hulk_atc').on('click', function () {
        $('.hulkapps_submit_cart').click();
    })


    hulk_attachPaginateListeners();
    hulk_getPaginateMax();
    hulk_paginate();
    previewElementObserver();

    // Gift box or individual bottles?

    if (document.querySelector('.giftbox_flavour')) {
        wrapGiftBoxDiv();
        getGiftBoxChoice();
        $('.custom_quantity select').find('option.price-change').attr('selected', 'selected').end().change();
        createInputButtons(document.querySelector('.custom_quantity input[type="number"]'));
        $('.custom_quantity input[type="number"]').attr('min', 1);
        monitorGiftSetFlavour();
        monitorExtraCharge_1_giftSet();
        monitorExtraCharge_2_giftSet()
        checkDesignFee();
        $('.custom_occasion input[type="text"]').attr('maxlength',30);
    } else if (document.querySelector('.inidividual_flavour')) {
        $('.inidividual_flavour').first().before(cocktailShowCase);
        monitorIndividualFlavour();
        monitorExtraCharge_1();
        $('.couples_names input[type="text"]').attr('maxlength',30);
    }

    $('.custom-font-picker').find('.radio_div').each(function(){
            $(this).css('font-family',$(this).prev().val());
        })
    // $('[id^="hulkapps_custom_options"]').removeClass('hulk_hide');

    monitorQrInput();
    $('#hulk-formbuilder-modal .hulkapps-modal-content').append($('.hulk_cocktail_preview .hulkapps_option_value').clone());
    $('.hulk_preview_button').hide();
    $('.hulk_custom_hide').css('opacity', '1');
}

window.addEventListener('load', () => {
    const hook = setInterval(() => {
        const hulk_div = document.querySelector('[class*="pagination_page-"]');
        if (hulk_div) {
            clearInterval(hook);
            hulk_custom_init();
        }
    }, 50)
})
